module.exports = __webpack_public_path__ + "static/media/pelvisNodes.cea91179.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/pelvisNodes.svg
// module id = 588
// module chunks = 19